import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AnalyticIdentify } from "@/features/my/_providers/analytic-identify";
import { CheckRoleProvider } from "@/features/my/_providers/check-role-provider";
import { PageViewTrackingProvider } from "@/features/my/_providers/page-view-tracking-provider";
import { ProtectedProvider } from "@/features/my/_providers/protected-provider";
import { SupportChatIdentify } from "@/features/my/_providers/support-chat-identify";

export const Route = createFileRoute("/(member)/(protected)")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ProtectedProvider>
      <CheckRoleProvider>
        <SupportChatIdentify>
          <AnalyticIdentify>
            <PageViewTrackingProvider>
              <Outlet />
            </PageViewTrackingProvider>
          </AnalyticIdentify>
        </SupportChatIdentify>
      </CheckRoleProvider>
    </ProtectedProvider>
  );
}
